// extracted by mini-css-extract-plugin
export default {"popup":"fUisYvSM6mlhliuo2lUL","small":"P_hekxokq4Fsxq_rHuHo","big":"_18VLEPQd6uAXQQkSXLC"};